import base from './base';
import palette from './palette';

const radius = base.shape.borderRadius as number;

declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    type: true;
  }
}

const chip = {
  MuiChip: {
    styleOverrides: {
      root: {
        fontSize: '12px',
        fontWeight: 500,
        height: '30px',
        borderRadius: radius,
      },
      sizeSmall: {
        fontSize: '14px',
        fontWeight: 400,
        height: 24,
      },
      label: {
        padding: '0 6px',
      },
      outlined: {
        backgroundColor: palette.common.white,
        fontSize: '16px',
        '&.MuiChip-colorDefault': {
          borderColor: palette.grey[600],
        },
        '&.MuiChip-colorSuccess': {
          backgroundColor: palette.green[100],
          borderColor: palette.green[600],
        },
        '&.MuiChip-colorWarning': {
          backgroundColor: palette.orange[100],
          borderColor: palette.orange[600],
        },
        '&.MuiChip-colorSecondary': {
          backgroundColor: palette.grey[100],
          borderColor: palette.grey[800],
        },
        '&.MuiChip-colorInfo': {
          backgroundColor: palette.common.white,
          borderColor: palette.common.black,
          color: palette.common.black,
          borderStyle: 'dashed',
        },
        '&.MuiChip-sizeSmall': {
          fontSize: '12px',
        },
      },
      type: {
        border: '1px solid',
        borderRadius: radius * 2,
        '&.MuiChip-sizeSmall': {
          fontWeight: 500,
          height: 22,
        },
        '& .MuiChip-label': {
          paddingInline: '12px',
        },
      },
    },
  },
};
export default chip;
